module.exports = __webpack_public_path__ + "img/account-circle.6c01fda5.svg";